/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-weather-partly-cloudy-day': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M79.941 43.641h-4a2 2 0 010-3.998h4a2 2 0 110 3.998zm-7.857-13.312a2 2 0 01-2.828-2.827l2.828-2.828a2 2 0 112.828 2.828l-2.828 2.827zm-2.947 15.607a11.949 11.949 0 012.806 7.705c0 6.625-5.372 11.998-11.999 11.998H43.946c-8.835 0-15.998-7.162-15.998-15.998s7.163-15.998 15.998-15.998c1.572 0 3.09.232 4.523.654 2.195-2.827 5.618-4.654 9.475-4.654 6.627 0 11.999 5.373 11.999 11.998a11.983 11.983 0 01-.806 4.295zm-37.19 3.705c0 6.627 5.371 11.998 11.998 11.998h15.998a8 8 0 000-15.998c-1.6 0-3.083.482-4.333 1.291-1.231-5.316-5.974-9.289-11.665-9.289-6.627 0-11.998 5.371-11.998 11.998zm25.996-15.998a7.972 7.972 0 00-5.662 2.349 16.113 16.113 0 015.629 5.854c.664-.113 1.337-.205 2.033-.205 2.125 0 4.119.559 5.85 1.527.096-.494.15-1.004.15-1.527a8 8 0 00-8-7.998zm0-8a1.999 1.999 0 01-1.999-1.999v-3.999a2 2 0 113.999 0v3.999a1.998 1.998 0 01-2 1.999zm-14.14 4.686l-2.827-2.827a2 2 0 012.827-2.828l2.828 2.828a1.998 1.998 0 11-2.828 2.827z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-weather-partly-cloudy-day.js